import React, { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const LearnToSwimFacilitiesStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const LearnToSwimFacilitiesContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <LearnToSwimFacilitiesStateContext.Provider value={stateHook}>
      {children}
    </LearnToSwimFacilitiesStateContext.Provider>
  );
};

export default LearnToSwimFacilitiesContextProvider;